import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {LaunchpadActions} from "@/pages/launchpad/LaunchpadActions.tsx";
import {LaunchpadContent} from "@/pages/launchpad/LaunchpadContent.tsx";

export const Launchpad = () => {
  return (
    <ContentContainer
      title="Launchpad"
      actionsBar={
        <Suspense>
          <LaunchpadActions />
        </Suspense>
      }
    >
      <Helmet>
        <title>Launchpad</title>
      </Helmet>
      <UpErrorBoundary>
        <Suspense>
          <LaunchpadContent />
        </Suspense>
      </UpErrorBoundary>
    </ContentContainer>
  );
};
